import { SquadWelcomeDialog } from '#src/components/squad/SquadWelcomeDialog/index.tsx';

const SquadPage = () => {
  return <SquadWelcomeDialog onConfirm={() => {}} />;
};
export default SquadPage;
